import {
  PersonaInfoSummary,
  TaskComment
} from '../../../../therapist/pages/tasks/types/Task'
import { axios, Response } from '..'

export interface EditTaskCommentRequest {
  content: string
}

export interface UpdateTaskCommentResponse {
  taskComment: TaskComment
  taggedPersons: PersonaInfoSummary
}

export const editTaskComment = (
  taskId: string,
  taskCommentId: string,
  request: EditTaskCommentRequest
): Response<UpdateTaskCommentResponse> => {
  return axios.patch(`/v1/tasks/${taskId}/comments/${taskCommentId}`, request)
}
